import type { TranslationLanguage } from './translation_types'

export const FALLBACK_TRANSLATION_LANGUAGES: TranslationLanguage[] = [{
  language_name: 'English',
  released: true,
  right_to_left: false,
  beta_only: false,
}]

function byDisplayOrder(first: TranslationLanguage, second: TranslationLanguage) {
  return (first.order ?? 0) - (second.order ?? 0)
}

export function sortByDisplayOrder(languages: TranslationLanguage[]): TranslationLanguage[] {
  return [...languages].sort(byDisplayOrder)
}

export function releasedLanguageNames(languages: TranslationLanguage[]): string[] {
  return languages.filter((language) => language.released).map((language) => language.language_name)
}

export function betaOnlyLanguageNames(languages: TranslationLanguage[]): string[] {
  return languages.filter((language) => language.beta_only).map((language) => language.language_name)
}

export function isRightToLeftLanguage(languages: TranslationLanguage[], languageName: string): boolean {
  return languages.some((language) => language.right_to_left && language.language_name === languageName)
}

// The server names languages in English and sends no code, so the code comes from the name.
const LANGUAGE_CODES_BY_NAME: Record<string, string> = {
  amharic: 'am', arabic: 'ar', bengali: 'bn', burmese: 'my', chinese: 'zh', dari: 'prs', english: 'en',
  farsi: 'fa', french: 'fr', german: 'de', gujarati: 'gu', 'haitian creole': 'ht', hindi: 'hi', hmong: 'hmn',
  italian: 'it', japanese: 'ja', khmer: 'km', korean: 'ko', nepali: 'ne', pashto: 'ps', persian: 'fa',
  polish: 'pl', portuguese: 'pt', punjabi: 'pa', russian: 'ru', somali: 'so', spanish: 'es', swahili: 'sw',
  tagalog: 'tl', ukrainian: 'uk', urdu: 'ur', vietnamese: 'vi'
}

export function languageCodeFor(languageName: string): string | undefined {
  return LANGUAGE_CODES_BY_NAME[languageName.trim().toLowerCase()]
}

// Vue 2 only raised the first letter, so names the API already capitalises keep their capitals.
export function languageMenuLabel(languageName: string): string {
  return languageName.charAt(0).toUpperCase() + languageName.slice(1)
}
